import { CategoryChart } from "../processors";
import { fetchCategoryChartParam } from "./fetchCategoryChartParam";
import { CategoryChartVisibilityFn } from "./types";
import * as visibilityFns from "../categoryChartVisibilityFns";
import { kpiCodeSplitter } from "../categoryChartQueryFns";
import _ from "lodash";
import { EMPTY_ARRAY, FilterMetadataApiWithCountReturn } from "../misc";

export const fetchCategoryChartVisibility = async (
    metadata: FilterMetadataApiWithCountReturn,
    locationAdminIds?: string[],
    categoryChart?: CategoryChart
): Promise<boolean> => {
    const defaultRet = false;
    const visibilityFnParams = (categoryChart?.visibilityFn ?? "").split(" ");
    const visibilityFn = visibilityFnParams[0];

    if (
        // !metadata ||
        !locationAdminIds ||
        !locationAdminIds.filter(d => d != null && d.toString().trim() !== "").length ||
        !categoryChart ||
        !visibilityFn ||
        !visibilityFns[visibilityFn]
    )
        return defaultRet;

    const params = await fetchCategoryChartParam(metadata, locationAdminIds, categoryChart);
    const kpis = _.uniqBy(
        _.flattenDeep(
            params?.kpis?.map(d => {
                const kpiCode = d[0];
                const schemeType = d[1];
                const subCodes = (kpiCode ?? "")
                    .split(kpiCodeSplitter)
                    .filter(d => d != null && d?.trim() !== "")
                    .map(d => d?.trim());

                return subCodes?.map(subCode => {
                    return {
                        kpiCode: subCode,
                        schemeType
                    };
                });
            }) ?? (EMPTY_ARRAY as { kpiCode: string; schemeType: string }[])
        ),
        d => _.join([d.kpiCode, d.schemeType], "###")
    ).map(d => {
        return [d.kpiCode, d.schemeType];
    });

    return (visibilityFns[categoryChart?.visibilityFn] as CategoryChartVisibilityFn)({
        ...params,
        kpis
    });
};
